import { render } from "./ExchangeHistory.vue?vue&type=template&id=5cf3ecf2&scoped=true&ts=true"
import script from "./ExchangeHistory.vue?vue&type=script&lang=ts"
export * from "./ExchangeHistory.vue?vue&type=script&lang=ts"

import "./ExchangeHistory.vue?vue&type=style&index=0&id=5cf3ecf2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf3ecf2"]])

export default __exports__